import React from 'react';
import styles from './HeroSection.module.css';
import {
    OptimizedMotionH1,
    OptimizedMotionP,
} from '../../../shared/ui/optimized-motion/OptimizedMotion';

const HeroSection = () => {
    return (
        <div className={styles.container}>
            <div className={styles.heroCard}>
                <div className={styles.backgroundEffects}>
                    <div className={styles.blurTopLeft} />
                    <div className={styles.blurBottomRightLarge} />
                    <div className={styles.blurBottomLeft} />
                    <div className={styles.blurRightPink} />
                    <div className={styles.blurTopLeftPink} />
                    <div className={styles.blurBottomCenterPink} />
                    <div className={styles.blurRightSmallYellow} />
                    <div className={styles.backgroundPattern} />
                </div>

                <div className={styles.content}>
                    <OptimizedMotionH1 className={styles.mainHeading} type="slide-down" delay={0.2}>
                        <span className={styles.gradientText}>Listen to Your </span>
                        <br />
                        <span className={styles.gradientText}>Voice</span>
                    </OptimizedMotionH1>

                    <div className={styles.descriptionContainer}>
                        <OptimizedMotionP
                            className={styles.description}
                            type="slide-up"
                            delay={0.4}
                        >
                            Every post, tweet, and video carries signals about tone, consistency,
                            and engagement. SimpleeCreate's Brand Analytics engine ingests those
                            signals in real time, benchmarking every asset against your style guide
                            and past performance. You finally see how closely each campaign stays
                            on‑brand—and where it drifts.
                        </OptimizedMotionP>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default HeroSection;
